/**
 *  @class
 *  @function FreeShipping
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {

      let amount_text = this.querySelector('.free-shipping--text span');
      let total = Number.parseInt(this.dataset.cartTotal, 10) || 0;
      const currencyRate = window.Shopify && Shopify.currency ? Shopify.currency.rate || 1 : 1;
      let minimum = Math.round((Number.parseInt(this.dataset.minimum, 10) || 0) * currencyRate);
      let percentage = minimum > 0 ? Math.min(Math.max(total / minimum, 0), 1) : 1;
      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');
      if (minimum > 0 && total < minimum) {

        if (amount_text) {
          let remaining = minimum - total,
            format = window.theme.settings.money_with_currency_format || "${{amount}}";
          amount_text.innerHTML = formatMoney(remaining, format);
        }
        this.remainingText.style.display = 'block';
        this.fullText.style.display = 'none';
      } else {
        this.remainingText.style.display = 'none';
        this.fullText.style.display = 'block';
      }

      this.style.setProperty('--percentage', percentage);

    }
  }
  customElements.define('free-shipping', FreeShipping);
}
